const emptyOrigin = (originURLString) => ({ url: originURLString, openNextAction: null });

/** Ids from the API and from `sfAction` are not always the same type. */
export const flyerIdsMatch = (left, right) => {
  if (left == null || right == null || left === '' || right === '') return false;
  return String(left) === String(right);
};

/**
 * Reads `sfAction.openNext` from the publisher URL stored on the iframe as `originURL`.
 * The returned `url` has `sfAction` removed so it can be forwarded into the Next iframe.
 */
export const parseOpenNextFromOriginUrl = (originURLString) => {
  if (!originURLString || typeof originURLString !== 'string') return emptyOrigin(originURLString);
  try {
    const url = new URL(originURLString);
    const sfAction = url.searchParams.get('sfAction');
    if (!sfAction) return emptyOrigin(originURLString);
    const action = JSON.parse(atob(decodeURIComponent(sfAction)));
    if (!action?.openNext) return emptyOrigin(originURLString);

    url.searchParams.delete('sfAction');
    return { url: url.href, openNextAction: action.openNext };
  } catch (error) {
    console.warn(`SV warning: unable to get sfAction from originURL`, error);
    return emptyOrigin(originURLString);
  }
};

export const sharedNextFlyerIdFromOrigin = (originURL) => {
  const flyerId = parseOpenNextFromOriginUrl(originURL).openNextAction?.flyerId;
  if (flyerId == null || flyerId === '') return null;
  return flyerId;
};

/** True only when the flyer already on the route is the one this Next share asked for. */
export const isSharedNextFlyer = (flyerId, originURL) =>
  flyerIdsMatch(flyerId, sharedNextFlyerIdFromOrigin(originURL));
